module.exports = __webpack_public_path__ + "img/button_join.a30e9ab1.png";